import React, { createContext, ReactNode, useContext } from "react";
import { NoomLoader } from "./components/noom-loader/NoomLoader";

export const appInitContext = createContext(false);

export function AppInitProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: boolean;
}) {
  return (
    <appInitContext.Provider value={value}>{children}</appInitContext.Provider>
  );
}

export function AppInitGate({ children }: { children: ReactNode }) {
  const isLoaded = useContext(appInitContext);
  return isLoaded ? <>{children}</> : <NoomLoader fullScreen />;
}
